import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////

const BG = {
	page: 'ManagedVPSPlans',
	brandColor: 'color-brand-purple-400',
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	page: 'ManagedVPSPlans',
	brandColor: 'color-brand-purple-400',
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];